<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-account-multiple" icon-small title="لیست مشتری ها" color="accent">
			<template v-slot:topActions>
				<v-btn color="primary " dark class="mx-1" @click="add">
					<v-icon dark>
						mdi-plus-circle-outline
					</v-icon>
					افزودن مشتری
				</v-btn>
			</template>
			<div cols="12" class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field @change="loadData" v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :options.sync="options" :server-items-length="countAll" dense :headers="headers" :loading="loading" :items="customers" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
							<template v-slot:item.firstName="{ item }">
								<a href="javascript:void(0)" @click="manageLoans(item)" class="info--text">{{ item.firstName }}</a>
							</template>
							<template v-slot:item.lastName="{ item }">
								<a href="javascript:void(0)" @click="manageLoans(item)" class="info--text">{{ item.lastName }}</a>
							</template>
							<template v-slot:item.regDate2_Persian.date="{ item }">
								<div style="direction: ltr;">{{ `${item.regDate2_Persian.date} ${item.regDate2_Persian.time != '00:00:00' ? item.regDate2_Persian.time : ''}` }}</div>
							</template>
							<template v-slot:item.totalLoans="{ item }">
								{{ item.totalLoans.toString().toPriceFormat() }}
							</template>
							<template v-slot:item.totalRemain="{ item }">
								{{ item.totalRemain.toString().toPriceFormat() }}
							</template>
							<template v-slot:item.operations="{ item }">
								<td class="text-center">
									<v-btn class="mx-1" fab dark small color="green" title="مدیریت وام ها" @click="manageLoans(item)">
										<v-icon dark>
											mdi-cash-check
										</v-icon>
									</v-btn>
									<v-btn class="mx-1" fab dark small color="secondary" @click="edit(item)">
										<v-icon dark>
											mdi-square-edit-outline
										</v-icon>
									</v-btn>
									<v-btn class="mx-1" fab dark small color="pink" @click="remove(item)">
										<v-icon dark>
											mdi-trash-can-outline
										</v-icon>
									</v-btn>
								</td>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
			<v-dialog v-model="dialogCustomer" scrollable persistent max-width="1000px">
				<modify-customer :data="selectedCustomer" v-if="dialogCustomer" @callbck="callbck" />
			</v-dialog>

			<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
				<v-card>
					<v-card-title>
						<div><span class="headline">لیست وام ها</span></div>
						<v-spacer />
						<v-btn @click="dialogLoansManager = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedCustomer }" />
					</v-card-text>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'MembersView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-customer': () => import('./ModifyCustomer'),
			'manage-loan': () => import('./ManageLoan'),
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				countAll: 0,
				errorMessages: '',
				datePickerValidatioin: '',
				localData: {},
				selectedCustomer: {},
				dialogCustomer: false,
				options: {},
				dialogLoansManager: false,
				itemsPerPage: 25,
				search: '',
				loading: false,
				headers: [
					{
						text: 'نام',
						align: 'start',
						sortable: true,
						value: 'firstName',
					}, {
						text: 'نام خانوادگی',
						align: 'start',
						sortable: true,
						value: 'lastName',
					}, {
						text: 'کد ملی',
						align: 'center',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'موبایل',
						align: 'center',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'تعداد وام',
						align: 'center',
						sortable: true,
						value: 'loanCount',
					}, {
						text: 'مجموع وام های دریافتی با بهره',
						align: 'center',
						sortable: true,
						value: 'totalLoans',
						width: 150,
					}, {
						text: 'مانده اقساط',
						align: 'center',
						sortable: true,
						value: 'totalRemain',
					},
					{
						text: 'تاریخ عضویت',
						align: 'center',
						sortable: true,
						value: 'regDate2_Persian.date',
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						value: 'operations',
						width: 225,
					},
				],
				customers: [],
			}
		},
		watch: {
			options: {
				handler() {
					this.loadData()
				},
				deep: true,
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				if (this.loading) {
					return
				}
				const data = {
					sortBy: this.options.sortBy,
					sortDesc: this.options.sortDesc,
					page: this.options.page || 1,
					itemsPerPage: this.options.itemsPerPage || this.itemsPerPage,
					all: true,
					search: this.search
				}
				this.loading = true
				api.post('agent/customer/DynamicList', data)
					.then(
						response => {
							this.customers = response.members
							this.countAll = response.countAll
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			add() {
				this.selectedCustomer = { id: 0 }
				this.dialogCustomer = true
			},
			edit(item) {
				this.selectedCustomer = item
				this.dialogCustomer = true
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('agent/customer/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			callbck(result) {
				this.dialogCustomer = false
				if (result)
					this.loadData(true)
			},
			manageLoans(item) {
				this.selectedCustomer = item
				this.dialogLoansManager = true
			}

		},
	}
</script>
<style></style>
